import React from "react";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";
import { Box } from "@dxp-feed/ui/Box";
import { HighlightText } from "./HighlightText";
import { RecipeType } from "@/utils/types/recipes";
import { ArticleType } from "@/utils/types/article";
import ImageWrapper from "@/components/ImageWrapper";
import { RecipeImage } from "@/utils/constant";
import { setDataLayerSlice } from "@/utils/redux/dataLayerSlice";
import { useAppDispatch } from "@/utils/hooks/reactUseCustomHooks";

interface SearchCategoryProps {
  type: "recipes" | "articles";
  data: RecipeType | ArticleType;
  iconWidth?: number;
  iconHeight?: number;
  className?: string;
  query?: string;
  tileDetails?: string;
  onClick?: () => void;
}

export const Tiles: React.FC<SearchCategoryProps> = ({
  type,
  data,
  className = "customClass ",
  tileDetails,
  iconWidth = 130,
  iconHeight = 70,
  query,
  onClick,
}) => {
  const dispatch = useAppDispatch();

  const dataLayePageSection = () => {
    dispatch(setDataLayerSlice("Search"));
  };

  let imageSrc: string;

  if (type === "recipes") {
    imageSrc = RecipeImage + (data as RecipeType)?.featuredImage;
  } else {
    const article = data as ArticleType;
    imageSrc =
      RecipeImage +
      (article?.videoUrl ? article.videoThumbnail : article.bannerImage);
  }

  return (
    <Box as="div" className={`flex flex-wrap items-center ${className} `}>
      {tileDetails ? (
        <Link
          href={data.pageSlug ? `/${type}/${data.pageSlug}` : "#"}
          aria-label={data?.title}
          className={`${tileDetails ? "block" : ""}`}
        >
          <Box
            as="div"
            className="card rounded-[12px]  bg-brandWhite flex flex-col bottom pb-[16px] px-[16px] pt-8 "
          >
            <Box
              as="div"
              className="relative my-[22px] h-[116px] flex flex-col justify-end"
            >
              <ImageWrapper
                className={`!relative w-[${iconWidth}px] mx-auto h-[${iconHeight}px]`}
                width={iconWidth}
                height={iconHeight}
                src={imageSrc}
                alt={data?.title ?? ""}
              />
            </Box>
            <Box as="div" className="pt-[16px] ">
              <Text
                as="h4"
                className="text-brandBlack text-[16px] font-bold pb-1 "
              >
                $10.29{" "}
              </Text>
              <Text
                as="p"
                className="text-sm font-normal text-brandBlack pb-[8px] "
              >
                608g($1.69 per 100g){" "}
              </Text>
              <Text
                as="p"
                className="text-sm text-brandBlack py-[0px] font-bold"
              >
                Sobeys
              </Text>
              <Text
                as="p"
                className="text-body font-normal text-brandBlack pt-[4px] pb-[0px] line-clamp-2"
              >
                {
                  <HighlightText
                    text={data?.title ?? ""}
                    query={query ?? ""}
                    highlightResult={data?._highlightResult}
                    attribute="title"
                  />
                }
              </Text>
            </Box>
          </Box>
        </Link>
      ) : (
        <Link
          href={data.pageSlug ? `/${type}/${data.pageSlug}` : "#"}
          aria-label={data?.title}
          className={`flex w-full`}
          onClick={() => {
            if (typeof onClick === "function") {
              onClick();
            }
            if (
              type === "recipes" &&
              typeof dataLayePageSection === "function"
            ) {
              dataLayePageSection();
            }
          }}
          tabIndex={0}
        >
          <Box
            as="div"
            className="card  w-full flex rounded-[12px] overflow-hidden "
          >
            <Box
              as="div"
              className="relative  2xs:w-[130px] 4xs:w-[82px] w-[62px] h-full "
            >
              <ImageWrapper
                className={`!relative w-[${iconWidth}px] mx-auto h-[${iconHeight}px]`}
                src={imageSrc}
                fill
                alt={data?.title ?? ""}
              />
            </Box>

            <Text
              as="h3"
              className="self-center   2xs:leading-[21px] 4xs:leading-[18px] leading-[16px]  px-[12px] flex-1 line-clamp-2 !py-0"
            >
              <HighlightText
                text={data?.title ?? ""}
                query={query ?? ""}
                highlightResult={data?._highlightResult}
                attribute="title"
              />
            </Text>
          </Box>
        </Link>
      )}
    </Box>
  );
};
